import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';

const httpOptions = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json'
  })
};
const httpOptionsFormData = {
  headers: new HttpHeaders({
    'Content-Type': 'multipart/form-data'
  })
};

@Injectable({
  providedIn: 'root'
})
export class RestapiService {
  // Development Server Configuration
  // API_ROUTE = 'http://10.2.0.4:8080';
  // FILE_PATH = 'http://10.2.0.4:8080/pent/';
  // CEO_API_ROUTE = 'http://10.2.0.4:8080/ceo';
  // ANALYST_DASH = 'http://10.2.0.4:8080/member';
  // PROJ_PATH = 'http://10.2.0.4:8080';
  // ADMIN_DASH = 'http://10.2.0.4:8080/admindash';

  // Production Local Configuration
  // API_ROUTE = 'http://localhost:8080';
  // FILE_PATH = 'http://localhost:8080/pent/';
  // CEO_API_ROUTE = 'http://localhost:8080/ceo';
  // ANALYST_DASH = 'http://localhost:8080/member';
  // PROJ_PATH = 'http://localhost:8080';
  // ADMIN_DASH = 'http://localhost:8080/admindash';

  // Production Configuration
  API_ROUTE = 'https://onlinemis.gicouncil.in/api';
  FILE_PATH = "https://onlinemis.gicouncil.in/pent/";
  CEO_API_ROUTE = 'https://onlinemis.gicouncil.in/ceo';
  ANALYST_DASH = 'https://onlinemis.gicouncil.in/member';
  PROJ_PATH = "https://onlinemis.gicouncil.in";
  ADMIN_DASH = "https://onlinemis.gicouncil.in/admindash";

  //UAT Configuration
  /*API_ROUTE = 'http://192.168.1.20:8080';
  FILE_PATH = "http://192.168.1.20:8080/pent/";
  CEO_API_ROUTE = 'http://192.168.1.20:8080/ceo';
  ANALYST_DASH = 'http://192.168.1.20:8080/member';
  PROJ_PATH = "http://192.168.1.20:8080";
  ADMIN_DASH = "http://192.168.1.20:8080/admindash";*/

  //UAT Configuration
  // API_ROUTE = 'http://192.168.6.15:9081';
  // FILE_PATH = "http://192.168.6.15/pent/";
  // CEO_API_ROUTE = 'http://192.168.6.15/ceo';
  // ANALYST_DASH = 'http://192.168.6.15/member';
  // PROJ_PATH = "http://192.168.6.15";
  // ADMIN_DASH = "http://192.168.6.15/admindash";



  PER_PAGE_ROW = 50;

  constructor(private http: HttpClient) {
  }

  ceoSignIn(data) {
    return this.http.post(this.CEO_API_ROUTE + '/auth/logapi', data);
  }

  signIn(data) {
    return this.http.post(this.API_ROUTE + '/signIn', data, httpOptions);
  }

  uplpadData(data) {
    return this.http.post(this.API_ROUTE + '/uploadFile', data);
  }

  listData(data) {
    return this.http.post(this.API_ROUTE + '/getFileList', data, httpOptions);
  }

  getPeerGroup(data) {
    return this.http.post(this.API_ROUTE + '/getPeerGroup', data, httpOptions);
  }

  addCompany(data) {
    return this.http.post(this.API_ROUTE + '/createCompany', data);
  }

  companyList(data) {
    return this.http.post(this.API_ROUTE + '/companyList', data);
  }

  userList(data) {
    return this.http.post(this.API_ROUTE + '/userList', data);
  }

  addUser(data) {
    return this.http.post(this.API_ROUTE + '/addUser', data);
  }

  delUser(data) {
    return this.http.post(this.API_ROUTE + '/delUser', data);
  }

  getFileDetails(data) {
    return this.http.post(this.API_ROUTE + '/getFileDetails', data);
  }

  companydelete(data) {
    return this.http.post(this.API_ROUTE + '/companydelete', data);
  }

  companyedit(data) {
    return this.http.post(this.API_ROUTE + '/companyedit', data);
  }

  helpDocUpload(data) {
    return this.http.post(this.API_ROUTE + '/helpDocUpload', data);
  }

  getHelpDoc(data) {
    return this.http.post(this.API_ROUTE + '/getHelpDoc', data);
  }

  getAdminFiles(data) {
    return this.http.post(this.API_ROUTE + '/getAdminFiles', data);
  }

  getSettingsData(data) {
    return this.http.post(this.API_ROUTE + '/getSettingsData', data);
  }

  updateSettingsData(data) {
    return this.http.post(this.API_ROUTE + '/updateSettingsData', data);
  }

  getLoginAudit(data) {
    return this.http.post(this.API_ROUTE + '/getLoginAudit', data);
  }

  getUserDetailsById(data) {
    return this.http.post(this.API_ROUTE + '/getUserDetailsById', data);
  }

  updateUser(data) {
    return this.http.post(this.API_ROUTE + '/updateUser', data);
  }

  getuserAudit(data) {
    return this.http.post(this.API_ROUTE + '/getuserAudit', data);
  }

  getConsoleView(data) {
    return this.http.post(this.API_ROUTE + '/getConsoleView', data);
  }

  getConsolidateReport(data) {
    return this.http.post(this.API_ROUTE + '/getConsolidateReport', data);
  }

  getConsolidateReportCompliance(data) {
    return this.http.post(this.API_ROUTE + '/getConsolidateReportCompliance', data);
  }

  changePassword(data) {
    return this.http.post(this.API_ROUTE + '/changePassword', data);
  }

  getCompanyAudit(data) {
    return this.http.post(this.API_ROUTE + '/getCompanyAudit', data);
  }

  fileDeleteRequest(data) {
    return this.http.post(this.API_ROUTE + '/fileDeleteRequest', data);
  }

  getDelRequest(data) {
    return this.http.post(this.API_ROUTE + '/getDelRequest', data);
  }

  getPendingRequest(data) {
    return this.http.post(this.API_ROUTE + '/getPendingRequest', data);
  }

  getPendingRequestAudit(data) {
    return this.http.post(this.API_ROUTE + '/getPendingRequestAudit', data);
  }

  approveRejectFileDeleteRequest(data) {
    return this.http.post(this.API_ROUTE + '/approveRejectFileDeleteRequest', data);
  }

  saveCustomReport(data) {
    return this.http.post(this.API_ROUTE + '/saveCustomReport', data);
  }

  getCustomReport(data) {
    return this.http.post(this.API_ROUTE + '/getCustomReport', data);
  }

  getFileAudit(data) {
    return this.http.post(this.API_ROUTE + '/getFileAudit', data);
  }

  companyListWithSearch(data) {
    return this.http.post(this.API_ROUTE + '/companyListWithSearch', data);
  }

  getUnlockConfig(data) {
    return this.http.post(this.API_ROUTE + '/getUnlockConfig', data);
  }

  saveUnlockConfig(data) {
    return this.http.post(this.API_ROUTE + '/saveUnlockConfig', data);
  }

  delUnlockConfig(data) {
    return this.http.post(this.API_ROUTE + '/delUnlockConfig', data);
  }

  checkFileConfig(data) {
    return this.http.post(this.API_ROUTE + '/checkFileConfig', data);
  }

  otherFileUpload(data) {
    return this.http.post(this.API_ROUTE + '/otherFileUpload', data);
  }

  getOtherFileList(data) {
    return this.http.post(this.API_ROUTE + '/getOtherFileList', data);
  }

  delOtherFile(data) {
    return this.http.post(this.API_ROUTE + '/delOtherFile', data);
  }

  consoleListAdmin(data) {
    return this.http.post(this.API_ROUTE + '/consoleListAdmin', data);
  }

  saveAdminCustomReport(data) {
    return this.http.post(this.API_ROUTE + '/saveAdminCustomReport', data);
  }

  getAdminCustomReport(data) {
    return this.http.post(this.API_ROUTE + '/getAdminCustomReport', data);
  }

  getFileDetailsById(data) {
    return this.http.post(this.API_ROUTE + '/getFileDetailsById', data);
  }
  setScheduler(data) {
    return this.http.post(this.API_ROUTE + '/setScheduler', data);
  }

  getFilterData(data) {
    return this.http.post(this.API_ROUTE + '/getFilterData', data);
  }

  getPremNPolForMonth(data) {
    return this.http.post(this.API_ROUTE + '/getPremNPolForMonth', data);
  }

  getPdStatPolPrem(data) {
    return this.http.post(this.API_ROUTE + '/getPdStatPolPrem', data);
  }

  getPdStatClaim(data) {
    return this.http.post(this.API_ROUTE + '/getPdStatClaim', data);
  }

  getPdChPolPrem(data) {
    return this.http.post(this.API_ROUTE + '/getPdChPolPrem', data);
  }

  getPdChClaim(data) {
    return this.http.post(this.API_ROUTE + '/getPdChClaim', data);
  }

  getAllPdTabData(data) {
    return this.http.post(this.API_ROUTE + '/getAllPdTabData', data);
  }

  getDownloadableFile(data) {
    return this.http.post(this.API_ROUTE + '/getDownloadableFile', data);
  }

  getSegmentPdUnapproveData(data) {
    return this.http.post(this.API_ROUTE + '/getSegmentPdUnapproveData', data);
  }

  getFormPdUnapproveData(data) {
    return this.http.post(this.API_ROUTE + '/getFormPdUnapproveData', data);
  }

  approveSegmentPdData(data) {
    return this.http.post(this.API_ROUTE + '/approveSegmentPdData', data);
  }

  approveFormPdData(data) {
    return this.http.post(this.API_ROUTE + '/approveFormPdData', data);
  }

  delHelpDoc(data) {
    return this.http.post(this.API_ROUTE + '/delHelpDoc', data);
  }

  forgotPsw(data) {
    return this.http.post(this.API_ROUTE + '/forgotPsw', data);
  }

  flashUpload(data) {
    return this.http.post(this.API_ROUTE + '/flashUpload', data);
  }
  /* Added by Santanu */
  updateFlashUpload(data) {
    return this.http.post(this.API_ROUTE + '/updateFlashUpload', data);
  }

  reqEditFlashUpload(data) {
    return this.http.post(this.API_ROUTE + '/reqEditFlashUpload', data);
  }

  approveRejectFlashUploadEditReq(data) {
    return this.http.post(this.API_ROUTE + '/approveRejectFlashUploadEditReq', data);
  }
  /* End */

  flashView(data) {
    return this.http.post(this.API_ROUTE + '/flashView', data);
  }

  flashReport(data) {
    return this.http.post(this.API_ROUTE + '/flashReport', data);
  }

  fileMatrix(data) {
    return this.http.post(this.API_ROUTE + '/fileMatrix', data);
  }
}
